var map = {
	"./ace.gif": 5537,
	"./ai.gif": 3010,
	"./alz.gif": 8959,
	"./arc.gif": 8460,
	"./arj.gif": 4445,
	"./avi.gif": 5350,
	"./bat.gif": 6533,
	"./bmp.gif": 5013,
	"./com.gif": 6903,
	"./doc.gif": 6546,
	"./docx.gif": 4998,
	"./etc.gif": 2970,
	"./etcimg.gif": 6383,
	"./exe.gif": 1772,
	"./gif.gif": 890,
	"./hwp.gif": 2281,
	"./ice.gif": 2457,
	"./jpg.gif": 1593,
	"./lha.gif": 7633,
	"./mp3.gif": 6422,
	"./pdf.gif": 8434,
	"./png.gif": 8665,
	"./ppt.gif": 8872,
	"./pptx.gif": 5624,
	"./psd.gif": 4905,
	"./rar.gif": 3423,
	"./tar.gif": 4993,
	"./txt.gif": 228,
	"./wordpad.gif": 9775,
	"./xls.gif": 8439,
	"./xlsx.gif": 1057,
	"./zip.gif": 3617
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4545;